import { useState, useEffect } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

export const useAnalysisData = translate => {
	const [stats, setStats] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchStats = async () => {
			const auth = getAuth();
			const currentUser = auth.currentUser;

			if (!currentUser) {
				setError(translate("error.userNotConnected"));
				setLoading(false);
				return;
			}

			try {
				setLoading(true);
				setError(null);

				const functions = getFunctions(undefined, "europe-west1");
				const getStatsFunction = httpsCallable(functions, "getStatsFunction");
				const result = await getStatsFunction();

				setStats(result.data);
			} catch (err) {
				console.error("Error while fetching stats:", err);
				setError(err.message || translate("error.generic"));
			} finally {
				setLoading(false);
			}
		};

		const auth = getAuth();
		const unsubscribe = auth.onAuthStateChanged(user => {
			if (user) {
				fetchStats();
			} else {
				setError(translate("error.userNotConnected"));
				setLoading(false);
			}
		});

		return () => unsubscribe();
	}, [translate]);

	const refetchStats = async () => {
		const auth = getAuth();
		const currentUser = auth.currentUser;

		if (!currentUser) {
			setError(translate("error.userNotConnected"));
			return;
		}

		try {
			setLoading(true);
			setError(null);

			const functions = getFunctions(undefined, "europe-west1");
			const getStatsFunction = httpsCallable(functions, "getStatsFunction");
			const result = await getStatsFunction();

			setStats(result.data);
		} catch (err) {
			console.error("Error while refetching stats:", err);
			setError(err.message || translate("error.generic"));
		} finally {
			setLoading(false);
		}
	};

	return {
		stats,
		loading,
		error,
		refetchStats,
	};
};
